export const DndContainer: {
  el?: HTMLElement
  abortController?: AbortController
  mounted: () => void
  destroyed: () => void
} = {
  mounted() {
    if (!this.el) {
      return
    }

    this.abortController = new AbortController()

    this.el.addEventListener(
      'dragenter',
      () => {
        if (!this.el) {
          return
        }

        this.el.classList.remove('bg-gray-50', 'border-gray-200')
        this.el.classList.add('bg-gray-100', 'border-gray-400', 'opacity-80')
      },
      { signal: this.abortController.signal },
    )

    this.el.addEventListener(
      'dragleave',
      () => {
        if (!this.el) {
          return
        }

        this.el.classList.remove('bg-gray-100', 'border-gray-400', 'opacity-80')
        this.el.classList.add('bg-gray-50', 'border-gray-200')
      },
      { signal: this.abortController.signal },
    )
  },
  destroyed() {
    this.abortController?.abort()
  },
}
